import _ from 'lodash';
import Backbone from 'backbone';

const PropertyListModel = Backbone.Model.extend({
    idAttribute: 'uuid',
    url: '/api/site',
    defaults: {
        url: '',
        city: '',
        name: '',
        state: '',
        status: 'DRAFT',
        zipCode: '',
        channel: '',
        version: 1,
        siteType: 'NEWS',
        imageUrl: 'http://placehold.it/256x140',
        affiliate: '',
        stagingUrl: '',
        description: '',
        callLetters: '',
        designatedMarketArea: '',
    },
    initialize() {
        this.idAttribute = 'uuid';
    },
    parse(data) {
        const model = data && (_.isArray(data.data) && data.data.length > 0) ? data.data[0] : data;

        if (model && model.response) {
            delete model.response;
        }

        return model;
    },
    getModelId() {
        return this.attributes.uuid;
    },
    getURL() {
        return this.attributes.url;
    },
    setURL(url) {
        this.set({url});
    },
    getCity() {
        return this.attributes.city;
    },
    setCity(city) {
        this.set({city});
    },
    getName() {
        return this.attributes.name;
    },
    setName(name) {
        this.set({name});
    },
    getState() {
        return this.attributes.state;
    },
    setState(state) {
        this.set({state});
    },
    getStatus() {
        return this.attributes.status;
    },
    setStatus(status) {
        this.set({status});
    },
    getVersion() {
        return this.attributes.version;
    },
    setVersion(version) {
        this.set({version});
    },
    getZipCode() {
        return this.attributes.zipCode;
    },
    setZipCode(zip) {
        this.set({zipCode: zip});
    },
    getChannel() {
        return this.attributes.channel;
    },
    setChannel(channel) {
        this.set({channel});
    },
    getSiteType() {
        return this.attributes.siteType;
    },
    setSiteType(siteType) {
        this.set({siteType});
    },
    getImageUrl() {
        return this.attributes.imageUrl;
    },
    setImageUrl(url) {
        this.set({imageUrl: url});
    },
    getAffiliate() {
        return this.attributes.affiliate;
    },
    setAffiliate(affiliate) {
        const affiliates = this.getAffiliate();

        if (!affiliates.includes(affiliate)) {
            affiliates.push(affiliate);
        }

        this.set({affiliate: affiliates});
    },
    getStagingUrl() {
        return this.attributes.stagingUrl;
    },
    setStagingUrl(url) {
        this.set({stagingUrl: url});
    },
    getDescription() {
        return this.attributes.description;
    },
    setDescription(description) {
        this.set({description});
    },
    getCallLetters() {
        return this.attributes.callLetters;
    },
    setCallLetters(callLetters) {
        this.set({callLetters});
    },
    getDesignatedMarketArea() {
        return this.attributes.designatedMarketArea;
    },
    setDesignatedMarketArea(dma) {
        this.set({designatedMarketArea: dma});
    },
});

export default PropertyListModel;
